import React, { Component } from 'react'
import { translate } from '../../utils/useful'

import DataMenu from './DataMenu'
import ToolsMenu from './ToolsMenu'
import ViewsMenu from './ViewsMenu'
import FrameSettingMenu from './FrameSettingMenu'
import SelectMenu from './SelectMenu'


export default class MessengerToolbar extends Component {

    state = {}

    componentDidMount() {
    }

    componentDidUpdate = (prevProps) => {
        // if (prevProps.data != this.props.data) { }
    }

    render() {
        return (
            <div className='w-100 flexc '>

                {/* <ViewsMenu permissions={this.props.permissions} colors={this.props.colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} headers={this.props.headers} view={this.props.view} isMobile={this.props.isMobile} />
                <DataMenu permissions={this.props.permissions} colors={this.props.colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} headers={this.props.headers} view={this.props.view} isMobile={this.props.isMobile} setCurrentHead={this.props.setCurrentHead} hasFilter={this.props.hasFilter} hasSortedBy={this.props.hasSortedBy} sortedBy={this.props.sortedBy} hasGroupBy={this.props.hasGroupBy} />
                <ToolsMenu permissions={this.props.permissions} colors={this.props.colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} headers={this.props.headers} view={this.props.view} isMobile={this.props.isMobile} /> */}
                <FrameSettingMenu permissions={this.props.permissions} colors={this.props.colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} headers={this.props.headers} view={this.props.view} isMobile={this.props.isMobile} />
                {/* <SelectMenu permissions={this.props.permissions} colors={this.props.colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} headers={this.props.headers} view={this.props.view} isMobile={this.props.isMobile} /> */}

                
            </div>
        )
    }
}
